export const device = {
  mobile: `(max-width: 37.5em)`,
  tablet: `(min-width: 37.5em) and (max-width: 64em)`,
  laptop: `(min-width: 64em) and (max-width: 90em)`,
  desktop: `(min-width: 90em)`,
};
